import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toPhone } from '@common/utils';

const LoginNotMatch = () => {
  const { userInfo, loginInfo } = useSelector(state => state.userReducer);

  const [bfCpNo, setBfCpNo] = useState(loginInfo.beforeCpNo);
  const history = useHistory();

  const onButtonClickHandler = () => {
    history.push('/login/authConfirm');
  };

  useEffect(() => {
    setBfCpNo(convertCpNo());
  }, []);

  const convertCpNo = () => {
    const splitCpNo = toPhone(bfCpNo).split('-');
    return (
      splitCpNo[0] + '-' + '*'.repeat(splitCpNo[1].length) + '-' + splitCpNo[2]
    );
  };
  return (
    <>
      <div className="page-navi">
        <button
          type="button"
          className="btn-back"
          onClick={() => history.goBack()}
        >
          <span className="hide">이전</span>
        </button>
      </div>

      <h2 className="tit">
        현재 KB라이프생명에서 확인되는 <br />
        <strong>{userInfo.username} 님의 휴대전화번호</strong>가<br />
        입력하신 정보와 다릅니다.
      </h2>

      <div className="logincon-area">
        <p className="title-h5">
          {/* TODO 휴대폰 중간번호 '*'설정 */}
          기존의 <strong className="bold">{bfCpNo}</strong>에서 입력하신{' '}
          <strong className="bold">{userInfo.cpNo}</strong>로 변경하시겠습니까?
        </p>
        <p className="text-info ico-type mgt-18">
          전화번호를 최신 정보로 유지하셔야 향후 서비스를 편리하게 사용하실 수
          있습니다.
        </p>
      </div>

      <div className="btn-area">
        <button
          type="button"
          className="btn-l blue"
          onClick={onButtonClickHandler}
        >
          본인 인증하고 변경하기
        </button>
      </div>
    </>
  );
};

export default LoginNotMatch;
